import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// ─── Currency & Number Formatters ──────────────────────────────────────────────

export function formatCurrency(value, opts = {}) {
  const { showParens = true, decimals = 0 } = opts;
  if (value === null || value === undefined || value === "" || isNaN(Number(value))) return "";
  const num = Number(value);
  const abs = Math.abs(num);
  const formatted = abs.toLocaleString("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  const str = `$${formatted}`;
  if (num < 0 && showParens) return `(${str})`;
  if (num < 0) return `-${str}`;
  return str;
}

export function formatMultiple(value, decimals = 2) {
  if (value === null || value === undefined || isNaN(Number(value))) return "";
  return `${Number(value).toFixed(decimals)}x`;
}

export function formatPercent(value, decimals = 2) {
  if (value === null || value === undefined || isNaN(Number(value))) return "";
  return `${Number(value).toFixed(decimals)}%`;
}

export function parseCurrency(str) {
  if (!str) return 0;
  return Number(String(str).replace(/[^0-9.-]/g, "")) || 0;
}

// ─── DSCR Calculations ─────────────────────────────────────────────────────────

export function calcDSCR(cashFlow, debtService) {
  if (!debtService || debtService === 0) return null;
  return cashFlow / debtService;
}

export function dscrColor(dscr) {
  if (dscr === null || dscr === undefined) return "text-gray-400";
  if (dscr >= 1.25) return "text-green-700 font-bold";
  if (dscr >= 1.0) return "text-yellow-700 font-bold";
  return "text-red-600 font-bold";
}

export function dscrBadge(dscr) {
  if (dscr === null || dscr === undefined) return "dscr-warn";
  if (dscr >= 1.25) return "dscr-pass";
  if (dscr >= 1.0) return "dscr-warn";
  return "dscr-fail";
}

export function dscrLabel(dscr) {
  if (dscr === null || dscr === undefined) return "N/A";
  if (dscr >= 1.25) return "PASS";
  if (dscr >= 1.0) return "MARGINAL";
  return "FAIL";
}

// ─── Period utilities ─────────────────────────────────────────────────────────

export function prorateFactor(months) {
  return months ? 12 / months : 1;
}

export function annualize(value, months) {
  return value * prorateFactor(months);
}
